import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { db } from "../db/firestore";
import { stringYMDHMS3 } from '../Utility/dateTime';
import { initialCheckIn } from '../configs'
import { normalSort } from '../Utility/sort';
import { formatTime } from '../Utility/function';

const initialState = {
    checkIns:[], // 
    model_CheckIn:false,
    selectedCheckIns:[],
    startDate:new Date(),
    endDate:new Date(),
    billDates:[]
};


// fetch bill
export const fetchCheckIn = createAsyncThunk(
  'checkIn/fetchCheckIn',
  async ({ shopId, billDate, selectedDate }) => {
    let data = [];
    // Split billDate into chunks of 10 elements each
    const chunkSize = 10;
    const billDateChunck = [];
    for (let i = 0; i < billDate.length; i += chunkSize) {
      billDateChunck.push(billDate.slice(i, i + chunkSize));
    }

    // Use Promise.all to make multiple queries
    const promises = billDateChunck.map(async (chunk) => {
      const query = db.collection('checkInHistory')
        .where("shopId", "==", shopId)
        .where('billDate', 'in', chunk);

      try {
        const qsnapshot = await query.get();
        if (qsnapshot.docs.length > 0) {
          qsnapshot.forEach((doc) => {
            
            const { clockIn, clockOut, ...rest } = doc.data();
            let obj = { 
                ...initialCheckIn,
                ...rest, 
                clockIn:formatTime(clockIn),
                clockOut:formatTime(clockOut),
                  
                id: doc.id, 
  
              }
            data.push(obj);
          });
        } else {
          console.log('No items found for chunk:', chunk);
        }
      } catch (err) {
        console.error('Error:', err);
      }
    });
    // Wait for all queries to complete
    await Promise.all(promises);
    return { data:normalSort('timestamp',data), billDate, selectedDate };
  }
);


export const checkInSlice = createSlice({
  name: 'checkIn',
  initialState,
  reducers: {
    clearCheckIn: state => {
      state.startDate = new Date();
      state.endDate = new Date();
      state.checkIns = [];
      state.selectedCheckIns = [];
      state.billDates = [];
    },
    updateStartDate: (state, action) => {
      state.startDate = action.payload
    },
    updateEndDate: (state, action) => {
      state.endDate = action.payload
    },
    updateCheckIns: (state, action) => {
      const { selectedDate } = action.payload
      state.selectedCheckIns = normalSort('clockOut',state.checkIns.filter(a=>[selectedDate].includes(a.billDate)))
    }, 
  },
  extraReducers: builder => {
    builder.addCase(fetchCheckIn.pending, state => {
      state.model_CheckIn = true
    })
    builder.addCase(fetchCheckIn.fulfilled, (state, action) => {
      const { data, billDate, selectedDate } = action.payload;
      const today = stringYMDHMS3(new Date());
    
      const isDuplicate = billDate.includes(today);
    
      state.checkIns = isDuplicate
        ? [
            ...state.checkIns.filter(checkIn => checkIn.billDate !== today),
            ...data,
          ]
        : [...state.checkIns, ...data];
    
      state.billDates.push(...billDate.filter(date => date !== today));
    
      state.selectedCheckIns = normalSort(
        'clockOut',
        state.checkIns.filter(checkIn => selectedDate.includes(checkIn.billDate))
      );
    
      state.model_CheckIn = false;
    });
    builder.addCase(fetchCheckIn.rejected, state => {
        state.model_CheckIn = false
    })
  }
})

export const { updateCheckIns, updateStartDate, updateEndDate, clearCheckIn } = checkInSlice.actions

export default checkInSlice.reducer